import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { css, StyleSheet } from 'aphrodite';
import { TSS_DARK_BLUE, TSS_BLUE_1, TSS_BLACK, locationShape, childrenPropType } from 'tss-core-lib-common';
import Icon from 'react-svg-ikon';

import { IMG_ICON_CHEVRON_RIGHT_SMALL } from '../img';

var styles = void 0;

var addReverseState = function addReverseState(location) {
  if (typeof location === 'string') {
    return {
      pathname: location,
      state: { reverse: true }
    };
  }

  return Object.assign({}, location, {
    state: Object.assign({}, location.state || {}, {
      reverse: true
    })
  });
};

var Crumb = function Crumb(_ref) {
  var children = _ref.children,
      location = _ref.location,
      label = _ref.label,
      isCurrent = _ref.isCurrent,
      isExternal = _ref.isExternal;

  if (location === null) {
    return null;
  }

  if (location.pathname === '') {
    return React.createElement(
      'div',
      { className: css(styles.currentCrumb) },
      children,
      React.createElement(
        'span',
        { className: css(styles.text, styles.currentText) },
        label
      )
    );
  }
  if (isExternal) {
    return React.createElement(
      'a',
      { href: location.pathname, className: css(styles.link) },
      React.createElement(
        'span',
        { className: css(styles.text, styles.currentText) },
        label
      )
    );
  }
  return isCurrent ? React.createElement(
    'div',
    { className: css(styles.currentCrumb) },
    children,
    React.createElement(
      'span',
      { className: css(styles.text, styles.currentText) },
      label
    )
  ) : React.createElement(
    NavLink,
    { to: addReverseState(location), className: css(styles.link), activeClassName: css(styles.link) },
    children,
    React.createElement(
      'span',
      { className: css(styles.text) },
      label
    )
  );
};

Crumb.propTypes = {
  location: locationShape,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  children: childrenPropType,
  isCurrent: PropTypes.bool.isRequired,
  isExternal: PropTypes.bool
};
Crumb.defaultProps = {
  children: null,
  location: null,
  isExternal: false
};

var Breadcrumbs = function Breadcrumbs(_ref2) {
  var crumbs = _ref2.crumbs;
  return React.createElement(
    'div',
    { className: css(styles.container) },
    crumbs.map(function (_ref3, i) {
      var location = _ref3.location,
          label = _ref3.label,
          isExternal = _ref3.isExternal;
      return React.createElement(
        Crumb,
        { key: location + label, location: location, label: label, isExternal: isExternal, isCurrent: i === crumbs.length - 1 },
        i > 0 ? React.createElement(Icon, { src: IMG_ICON_CHEVRON_RIGHT_SMALL, stroke: TSS_DARK_BLUE(0.25), className: css(styles.chevron) }) : null
      );
    })
  );
};

Breadcrumbs.propTypes = {
  crumbs: PropTypes.arrayOf(PropTypes.shape({
    location: locationShape,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    isExternal: PropTypes.bool
  })).isRequired
};

Breadcrumbs.defaultProps = {};

styles = StyleSheet.create({
  container: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: TSS_BLUE_1(),
    padding: '2.4rem 2.1rem'
  },

  link: {
    textDecoration: 'none',
    color: TSS_DARK_BLUE(0.75),
    fontSize: '1.5rem',
    display: 'flex',
    alignItems: 'center'
  },

  currentCrumb: {
    fontSize: '1.5rem',
    display: 'flex',
    alignItems: 'center'
  },

  text: {
    position: 'relative',
    top: 1
  },

  currentText: {
    color: TSS_BLACK(0.5)
  },

  chevron: {
    margin: '0 1.1rem 0 1.2rem'
  }
});

export default Breadcrumbs;